export default __webpack_public_path__ + "static/media/The_Nest_large_6.fe440f29.jpg";